import { map } from 'lodash'
var _ = require('underscore');


const LOAD_SUPERVISION_ERRORS = 'server-sts/supervision/LOAD_SUPERVISION_ERRORS';
const LOAD_SUPERVISION_ERRORS_SUCCESS = 'server-sts/supervision/LOAD_SUPERVISION_ERRORS_SUCCESS';
const LOAD_SUPERVISION_ERRORS_FAIL = 'server-sts/supervision/LOAD_SUPERVISION_ERRORS_FAIL';

const RESET_FORM = 'server-sts/supervision/RESET_FORM';


const SORT_COLUMN = 'server-sts/supervision/SORT_COLUMN';
const SORT_COLUMN_SUCCESS = 'server-sts/supervision/SORT_COLUMN_SUCCESS';
const SORT_COLUMN_FAIL = 'server-sts/supervision/SORT_COLUMN_FAIL';
const RESET_COLUMN_SORT = 'server-sts/supervision/RESET_COLUMN_SORT';

const FILTER = 'server-sts/supervision/FILTER';
const FILTER_SUCCESS = 'server-sts/supervision/FILTER_SUCCESS';
const FILTER_FAIL = 'server-sts/supervision/FILTER_FAIL';


const EXPORT_CSV = 'server-sts/supervision/EXPORT_CSV';
const EXPORT_CSV_SUCCESS = 'server-sts/supervision/EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAIL = 'server-sts/supervision/EXPORT_CSV_FAIL';


const RESET_FILTER = 'server-sts/supervision/RESET_FILTER';

const RESOLVE_ERROR_ROWS = 'server-sts/supervision/RESOLVE_ERROR_ROWS';
const RESOLVE_ERROR_ROWS_SUCCESS = 'server-sts/supervision/RESOLVE_ERROR_ROWS_SUCCESS';
const RESOLVE_ERROR_ROWS_FAIL = 'server-sts/supervision/RESOLVE_ERROR_ROWS_FAIL';



const UNMOUNT = 'server-sts/supervision/UNMOUNT';



const initialState = {
  loaded: false,
  loading: false,
  created: false,
  supervisionCreatedError: false,
  editing: {},
  saveError: {},
  saveSuccess: false,
  currentPage: 1,
  sorting: { columns: {} },
  filter: {},
  data: [],
  pristineData: [],
  csv_data: [],
  ids: [],
  addresses: [],
  numsAsc: [],
  callTypes: [],
  anomalies: [],
  all: []
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {


    case SORT_COLUMN:

      return {
        ...state,
        loading: true,
        sorting: {
          columns: {
            ...state.sorting.columns,
            [action.obj.column]: action.obj.direction
          }
        }
      };
    case SORT_COLUMN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.result.rows,
        sorting: {
          columns: {
            ...state.sorting.columns,
          }
        }
      };
    case SORT_COLUMN_FAIL:
      return {
        ...state,
        loading: false,
        sorting: {
          columns: {
            ...state.sorting.columns,
          }
        }
      };

    case RESET_COLUMN_SORT:
      return {
        ...state,
        loading: false,
        sorting: {
          columns: {}
        }
      };

    case RESET_FILTER:
      return {
        ...state,
        filter: {}
      };


    case LOAD_SUPERVISION_ERRORS:
      return {
        ...state,
        loading: true
      };


    case LOAD_SUPERVISION_ERRORS_SUCCESS:
      if (!state.pristineData) {
        var pristineData = action.result.pristineRows;
      } else {
        var pristineData = state.pristineData;
      }


      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result.rows,
        currentPage: action.result.currentPage,
        supervisionNb: action.result.supervisionNb,
        pages: action.result.pages,
        error: null,
        pristineData,
        ids: action.result.ids,
        addresses: action.result.addresses,
        numsAsc: action.result.numsAsc,
        callTypes: action.result.callTypes,
        orphans: action.result.orphans,
        anomalies: action.result.anomalies,
        all: action.result.pages * 10
      };

    case LOAD_SUPERVISION_ERRORS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };


    case FILTER:
      return {
        ...state,
        filter: action.filter,
        loading: true
      };

    case FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result.rows,
        currentPage: action.result.currentPage,
        supervisionNb: action.result.supervisionNb,
        pages: action.result.pages,
        error: null,
        ids: action.result.ids,
        addresses: action.result.addresses,
        numsAsc: action.result.numsAsc,
        callTypes: action.result.callTypes,
        orphans: action.result.orphans,
        anomalies: action.result.anomalies

      };

    case FILTER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      };




    case RESET_FORM:
      return {
        ...state,
        created: false,
        loading: false,
        supervisionCreatedError: false,
      };


    case UNMOUNT:
      return {
        ...state,
        data: [],
        pristineData: [],
        filter: {},
        loaded: false
      };



    case EXPORT_CSV:
      return {
        ...state,
        csv_loading: true
      };

    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
        csv_success: true,
        csv_error: false,
        csv_loading: false,
        csv_data: action.result,
      };

    case EXPORT_CSV_FAIL:
      return {
        ...state,
        csv_success: false,
        csv_error: true,
        csv_loading: false
      };

    case RESOLVE_ERROR_ROWS:
      return {
        ...state,
        errorRowsResolved: false,
        errorRowsError: false,
        errorRowsLoading: true,
      };

    case RESOLVE_ERROR_ROWS_SUCCESS:
      return {
        ...state,
        errorRowsResolved: true,
        errorRowsError: false,
        errorRowsLoading: false,
      };

    case RESOLVE_ERROR_ROWS_FAIL:
      return {
        ...state,
        errorRowsResolved: false,
        errorRowsError: true,
        errorRowsLoading: false,
      };


    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.supervision && globalState.supervision.loaded;
}


export function createFiche(values) {
  if (values.localisation_adresse != null) {
    if (typeof values.localisation_adresse === 'object') {
      values.localisation_adresse = values.localisation_adresse.label;
    }
  }

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (supervision) => supervision.post('/supervision/create', {
      data: {
        values
      }
    })
  };
}
/*
export function load(page, params, columns, filter=null) {
	
  return {
    promise: (client) => client.post('/supervision/load', {data:{page, params, columns, filter}}),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
  };
}
*/

export function loadSupervisionErrors(page, params, columns, filter = null) {

  return {
    promise: (client) => client.post('/supervision/loadSupervisionErrors', { data: { page, params, columns, filter } }),
    types: [LOAD_SUPERVISION_ERRORS, LOAD_SUPERVISION_ERRORS_SUCCESS, LOAD_SUPERVISION_ERRORS_FAIL],
  };
}


export function changeFilter(page = 1, filter, params, columns) {
  return {
    promise: (client) => client.post('/supervision/load', { data: { params, filter, page, columns } }),
    types: [FILTER, FILTER_SUCCESS, FILTER_FAIL], filter
  };
}

export function sortColumn(page = 1, obj, params) {
  var columns = { [obj.column]: obj.direction }
  return {
    promise: (supervision) => supervision.post('/supervision/load', { data: { params, columns, page } }),
    types: [SORT_COLUMN, SORT_COLUMN_SUCCESS, SORT_COLUMN_FAIL], obj
  };
}

export function save(values, fields) {
  if (values.localisation_adresse != null) {
    if (typeof values.localisation_adresse === 'object') {
      values.localisation_adresse = values.localisation_adresse.label;
    }
  }

  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: values.id,
    promise: (client) => client.post('/supervision/update', {
      data: { ...values, gsm_dirty: fields.identification_GSM.dirty },
    })
  };
}

export function deleteFiche(id) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    promise: (supervision) => supervision.post('/supervision/deleteFiche', {
      data: { id }
    })
  };
}


export function exportCSV(params, filter, columns) {
  return {
    types: [EXPORT_CSV, EXPORT_CSV_SUCCESS, EXPORT_CSV_FAIL],
    promise: (supervision) => supervision.post('/supervision/exportCSV', {
      data: { params, filter, columns }
    })
  };
}

export function resolveErrorRows(params, checkedRows) {
  return {
    types: [RESOLVE_ERROR_ROWS, RESOLVE_ERROR_ROWS_SUCCESS, RESOLVE_ERROR_ROWS_FAIL],
    promise: (supervision) => supervision.post('/supervision/resolveErrorRows', {
      data: { params, checkedRows }
    })
  };
}



export function resetFormCs() {
  return { type: RESET_FORM };
}


export function unmount() {
  return { type: UNMOUNT };
}


export function resetColumnSort() {
  return { type: RESET_COLUMN_SORT };
}

export function resetFilter() {
  return { type: RESET_FILTER };
}

